// Generated by purs version 0.15.0
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Monad_Except from "../Control.Monad.Except/index.js";
import * as Control_Monad_Writer_Class from "../Control.Monad.Writer.Class/index.js";
import * as Control_Monad_Writer_Trans from "../Control.Monad.Writer.Trans/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Identity from "../Data.Identity/index.js";
import * as Data_List_Types from "../Data.List.Types/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Exception_Unsafe from "../Effect.Exception.Unsafe/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as JQuery from "../JQuery/index.js";
import * as Utils_JQuery from "../Utils.JQuery/index.js";
var Cmd = function (x) {
    return x;
};
var semigroupCmd = {
    append: function (v) {
        return function (v1) {
            return function (dispatch) {
                return function __do() {
                    v(dispatch)();
                    return v1(dispatch)();
                };
            };
        };
    }
};
var safeState = function (dictDecode) {
    return function (v) {
        var v1 = Control_Monad_Except.runExcept(Foreign_Generic_Class.decode(dictDecode)(v));
        if (v1 instanceof Data_Either.Left) {
            return Effect_Exception_Unsafe.unsafeThrow(Data_Show.show(Data_List_Types.showNonEmptyList(Foreign.showForeignError))(v1.value0));
        };
        if (v1 instanceof Data_Either.Right) {
            return v1.value0;
        };
        throw new Error("Failed pattern match at Utils.Elm (line 70, column 15 - line 72, column 23): " + [ v1.constructor.name ]);
    };
};
var safeUpdate = function (dictDecode) {
    return function (update$prime) {
        var $19 = safeState(dictDecode);
        return function ($20) {
            return update$prime($19($20));
        };
    };
};
var safeView = function (dictDecode) {
    return function (view$prime) {
        return function (el) {
            var $21 = view$prime(el);
            var $22 = safeState(dictDecode);
            return function ($23) {
                return $21($22($23));
            };
        };
    };
};
var safeInit = function (dictDecode) {
    return function (init$prime) {
        var $24 = safeState(dictDecode);
        return function ($25) {
            return init$prime($24($25));
        };
    };
};
var onInitOrUpdate = function (element) {
    return function (initializer) {
        return function (updater) {
            return function __do() {
                var initValueForeign = Utils_JQuery.getData("init-value")(element)();
                var $16 = Foreign.isUndefined(initValueForeign);
                if ($16) {
                    var value = initializer();
                    return Utils_JQuery.setData("init-value")(Foreign.unsafeToForeign(value))(element)();
                };
                return updater(Foreign.unsafeFromForeign(initValueForeign))();
            };
        };
    };
};
var onInit = function (element) {
    return function (initializer) {
        return function __do() {
            var initialized = Utils_JQuery.getAttr("data-initialized")(element)();
            return Control_Applicative.unless(Effect.applicativeEffect)(initialized === "true")(function __do() {
                initializer();
                return JQuery.setAttr("data-initialized")("true")(element)();
            })();
        };
    };
};
var onChange = function (dictDecode) {
    return function (input) {
        return function (dispatch) {
            return function (action) {
                return function __do() {
                    var v = JQuery.getValue(input)();
                    return Data_Foldable.for_(Effect.applicativeEffect)(Data_Foldable.foldableEither)(Control_Monad_Except.runExcept(Foreign_Generic_Class.decode(dictDecode)(v)))(function (val) {
                        return dispatch(action(val));
                    })();
                };
            };
        };
    };
};
var newtypeCmd = {
    Coercible0: function () {
        return undefined;
    }
};
var monoidCmd = {
    mempty: function (dispatch) {
        return Control_Applicative.pure(Effect.applicativeEffect)(Data_Unit.unit);
    },
    Semigroup0: function () {
        return semigroupCmd;
    }
};
var mapDispatch = function (tag) {
    return function (dispatch) {
        return function ($26) {
            return dispatch(tag($26));
        };
    };
};
var functorCmd = {
    map: function (f) {
        return function (v) {
            return function (h) {
                return v(function ($27) {
                    return h(f($27));
                });
            };
        };
    }
};
var mapCmd = function (f) {
    return Control_Monad_Writer_Trans.mapWriterT(Data_Functor.map(Data_Identity.functorIdentity)(Data_Functor.map(Data_Tuple.functorTuple)(Data_Functor.map(functorCmd)(f))));
};
var effect = function (dictMonadTell) {
    return function (eff) {
        return Control_Monad_Writer_Class.tell(dictMonadTell)(function (dispatch) {
            return eff;
        });
    };
};
var command = function (dictMonadTell) {
    return Control_Monad_Writer_Class.tell(dictMonadTell);
};
export {
    Cmd,
    safeInit,
    safeUpdate,
    safeView,
    onInit,
    onChange,
    mapDispatch,
    command,
    mapCmd,
    effect,
    onInitOrUpdate,
    functorCmd,
    semigroupCmd,
    monoidCmd,
    newtypeCmd
};
//# sourceMappingURL=index.js.map
